module.exports = __webpack_public_path__ + "static/media/modal_code_bg.aa0ef1b8.png";